import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../service";

export const useLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle login logic
  const handleLogin = async () => {
    const { email, password } = formData;

    if (!email || !password) {
      setLoginError("Veuillez remplir tous les champs !");
      return;
    }

    try {
      setLoading(true);
      setLoginError("");

      const res = await authService.login(email, password);
      const token = res.data.access_token;

      localStorage.setItem("access_token", token);

      navigate("/home");
    } catch (err) {
      console.error("Login error:", err);

      // Handle customized backend errors
      if (err.response) {
        const { status, data } = err.response;

        switch (status) {
          case 400:
            setLoginError(
              data.detail || "Requête invalide. Veuillez vérifier vos données."
            );
            break;
          case 401:
            setLoginError("Email ou mot de passe incorrect !");
            break;
          case 403:
            setLoginError("Accès refusé. Votre compte n’est pas autorisé.");
            break;
          case 404:
            setLoginError("Utilisateur non trouvé. Vérifiez votre email.");
            break;
          case 500:
            setLoginError("Erreur interne du serveur. Réessayez plus tard.");
            break;
          default:
            setLoginError(data.detail || "Une erreur inconnue s'est produite.");
        }
      } else if (err.request) {
        setLoginError(
          "Impossible de contacter le serveur. Vérifiez votre connexion Internet."
        );
      } else {
        setLoginError("Erreur inattendue : " + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    loginError,
    handleChange,
    handleLogin,
  };
};
